import { INutritionalValue, IProduct } from '@monofront/types';
import { getPrismicContent } from '@monofront/business/utils';
import { IPrismicNutrition, INutrition } from './types';

export const mapNutrition = (
  prismicContent: IPrismicNutrition[],
  product: IProduct,
): INutrition => {
  const content = getPrismicContent(prismicContent, product);
  const {
    information_title: informationTitle,
    ingredients_title: ingredientsTitle,
    nutritional_values_title: nutritionalValuesTitle,
    title,
    position_desktop: positionDesktop,
    position_mobile: positionMobile,
  } = content.primary;

  const nutrition: INutrition = {
    informationTitle,
    ingredientsTitle,
    nutritionalValuesTitle,
    title,
    positionDesktop,
    positionMobile,
  };

  return nutrition;
};

/**
 * Map data from Prismic Custom Type "Nutritional Values"
 */
export const mapNutrionalValues = (nutritionalValues: INutritionalValue[]) => {
  const NUTRITIONAL_VALUES = {};

  nutritionalValues.forEach((nutritionalValue) => {
    const { key, translation } = nutritionalValue;

    NUTRITIONAL_VALUES[key] = translation;
  });

  return NUTRITIONAL_VALUES;
};
